import './CountDown.css'
import React from 'react';
import CountDown from "./CountDown/CountDown.jsx";
import moment from 'moment';
import { Link } from "react-scroll";
import close from '../../img/close_popup.svg'

export default class Countdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isCountdown: true,
            deadLine: moment.utc('2023-07-11T12:00:00+03:00'),
            scroll: 0,
            packages: [
                {
                    price: '$299 >> $350 soon',
                    title: 'NO RECORDINGS access',
                },
                {
                    price: '$349 >> $500 soon',
                    title: 'FULL Access 🔥',
                },
                {
                    price: '$449 >> $800 soon',
                    title: '2 QA Events',
                },
                {
                    price: '$499 >> $1200 soon',
                    title: 'ChatGPT best practices',
                },
            ],
            activePackage: 0,
        }

        this.pageLink = window.location.href.toString();
        this.indexUtm = this.pageLink.indexOf('?');
        this.utm = this.pageLink.slice(this.indexUtm + 1);

        this.showCountdown = this.showCountdown.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.myCallback = this.myCallback.bind(this);
    }

    myCallback() {
        if (this.state.activePackage < 3) {
            this.setState({
                activePackage: this.state.activePackage + 1
            });
        } else {
            this.setState({
                activePackage: 0
            });
        }
    }

    showCountdown() {
        this.setState({
            isCountdown: !this.state.isCountdown
        });
    }

    handleScroll() {
        this.setState({
            scroll: window.scrollY
        });
    }

    componentDidMount = () => {
        setInterval(this.myCallback, 2000);
    }

    componentWillMount = () => {
        window.addEventListener("scroll", this.handleScroll);
        return () => window.removeEventListener("scroll", this.handleScroll);
    }

    render() {
        return (
            <React.Fragment>
                {moment().isBefore(this.state.deadLine) && this.state.scroll > 500 && <div>
                    {this.state.isCountdown && <div className='countdown-wrap red_grad'>
                        <div id="countdown" className="countdown">
                            <div className='countdown-content-block'>
                                <div className='countdown_text_block'>
                                    <p className='countdown-descr'>{this.state.packages[this.state.activePackage].title}</p>
                                    <p className='countdown-descr'>{this.state.packages[this.state.activePackage].price}</p>
                                </div>
                                <div className='countdown-main'>
                                    <p className='countdown-descr'>Don't miss out!</p>
                                    <CountDown futureDate={this.state.deadLine}></CountDown>
                                </div>
                                <Link
                                    activeClass="active"
                                    to='tickets'
                                    spy={true}
                                    smooth={true}
                                    offset={0}
                                    className='countdown_btn'
                                >
                                    GET TICKET
                                </Link>
                            </div>
                            <img onClick={this.showCountdown} className='close_countdown' src={close} alt='' />
                        </div>
                    </div>}
                </div>}
            </React.Fragment>
        )
    }
}
